<template>
  <div id="login">
    <div class="mx-auto" v-if="loading">
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <!-- <div class="container">
      <FlashMessage :position="'right top'" />

      <form>
        <div>
          <div class="title display-3" id="title">Owner Login</div>

          <div class="form-group">
            <input
              type="email"
              class="form-control"
              placeholder="Enter your email"
              v-model="email"
            />
          </div>

          <div class="form-group">
            <input
              type="password"
              class="form-control"
              placeholder="Enter your password"
              v-model="password"
            />
          </div>
        </div>

        <button class="btn btn-block" v-on:click.prevent="posting">
          submit
        </button>

        <router-link style="float: right; color: aliceblue" to="/resetpassword">
          forgot password ?
        </router-link>
      </form>
    </div> -->

    <div class="mx-auto login-form">
       <FlashMessage :position="'right top'" />
        <form>
            <h2 class="text-center">Owner Login</h2>       
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Email Address" v-model="email" required="required">
            </div>
            <div class="form-group">
                <input type="password" class="form-control" placeholder="Password" v-model="password" required="required">
            </div>
            <div class="form-group">
                <button type="submit" v-on:click.prevent="posting" class="btn btn-primary btn-block">Login</button>
            </div>
            <div class="clearfix">
            <router-link style="float: right" to="/resetpassword">
              Forgot Password?
            </router-link>  
            </div>        
        </form>
     
    </div>


  </div>
</template>

<script>
//import { fb } from "../firebase";
import axios from "axios";
export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false,
    };
  },

  methods: {
    posting: async function () {
      this.loading = true;
      await axios
        .post("https://pg-v1.herokuapp.com/signin", {
          email: this.email,
          password: this.password,
        })
        .then((res) => {
          console.log(res);

          localStorage.setItem("email", btoa(this.email));
          localStorage.setItem("password", btoa(this.password));

          localStorage.setItem("localid", res.data.localId);
          localStorage.setItem("idtoken", res.data.idToken);

          this.$router.push("pgowner");
          location.reload();
          location.reload();
        })
        .catch((err) => {
          console.log(err.response.data);

          this.flashMessage.setStrategy("single");
          this.flashMessage.error({
            message: err.response.data,
            time: 3000,
            blockClass: "custom-block-class",
          });
          console.log("please enter valid data");
        });
      this.loading = false;
    },
  },

  async created() {
    if (
      atob(localStorage.getItem("email")) != null &&
      atob(localStorage.getItem("password")) != null &&
      localStorage.getItem("email") != null &&
      localStorage.getItem("password") != null
    ) {
      this.loading = true;
      await axios
        .post("https://pg-v1.herokuapp.com/signin", {
          email: atob(localStorage.getItem("email")),
          password: atob(localStorage.getItem("password")),
        })
        .then((res) => {
          console.log(res);
          localStorage.setItem("localid", res.data.localId);
          localStorage.setItem("idtoken", res.data.idToken);
          this.$router.push("pgowner");
          location.reload();
          location.reload();
        })
        .catch((err) => {
          console.log(err.response.data);
          this.flashMessage.setStrategy("single");
          this.flashMessage.error({
            message: err.response.data,
            time: 3000,
            blockClass: "custom-block-class",
          });
          console.log("please enter valid data");
        });
      this.loading = false;
    }
  },
};
</script>

<style  src='../assets/css/login.css' scoped>
</style>


<style scoped>
#login {
  background-color: rgb(66, 66, 66);
  min-height: 100vh;
}

.title {
  color: aliceblue;
  font-size: 3em;
}

.spinner-grow {
  position: fixed;
  left: 0px;
  top: 25%;
  width: 100%;
  height: 50%;
  z-index: 9999;
  background: url("//upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Phi_fenomeni.gif/50px-Phi_fenomeni.gif")
    50% 50% no-repeat;
}
</style>